var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "newsletter-subscribe" }, [
    _vm.showTitle
      ? _c("div", { staticClass: "header" }, [
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("messages_nl.newsletter.search.title"))),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "content",
      domProps: { innerHTML: _vm._s(JSON.parse(_vm.newsletterHtml)) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }